// client/src/components/StatisticsCards.jsx
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const StatisticsCards = ({ stats }) => {
    const cards = [
        { label: 'Всего ОУ', value: stats.total_schools || 0, icon: 'building', color: '#0d6efd' },
        { label: 'ОУ с данными', value: stats.schools_with_data || 0, icon: 'check-circle', color: '#198754' },
        { label: 'Просмотры', value: stats.total_views || 0, icon: 'eye', color: '#ffc107' },
        { label: 'Пользователи', value: stats.unique_users || 0, icon: 'people', color: '#dc3545' },
        { label: 'Ученики', value: stats.unique_students || 0, icon: 'person', color: '#0dcaf0' },
        { label: 'Учителя', value: stats.unique_teachers || 0, icon: 'person-badge', color: '#6f42c1' }
    ];

    return (
        <Row className="g-3 mb-4">
            {cards.map((card, idx) => (
                <Col key={idx} lg={2} md={4} sm={6} xs={6}>
                    <div className="stat-card">
                        <i className={`bi bi-${card.icon}`} style={{ fontSize: '2rem', color: card.color }}></i>
                        <div className="stat-value">{card.value.toLocaleString()}</div>
                        <div className="stat-label">{card.label}</div>
                    </div>
                </Col>
            ))}
        </Row>
    );
};

export default StatisticsCards;